<a class="back-button" [routerLink]="destination" [queryParams]="queryParams">
  <span class="back-button__icon" aria-hidden="true"></span>
  <span>Back</span>
</a>
